import { sendDigitalDataEvent } from "@cinch-nx/shared-analytics";
export const saveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-in-favourite",
            category: "button",
            action: "favourite",
            label: "logged in"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
export const unSaveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-in-unfavourite",
            category: "button",
            action: "unfavourite",
            label: "logged in"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
export const unAuthSaveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-out-favourite",
            category: "button",
            action: "favourite",
            label: "logged out"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
export const sendSaveVehicleEvent = (context)=>sendDigitalDataEvent(saveVehicleEvent(context));
export const sendUnSaveVehicleEvent = (context)=>sendDigitalDataEvent(unSaveVehicleEvent(context));
export const sendUnAuthSaveVehicleEvent = (context)=>sendDigitalDataEvent(unAuthSaveVehicleEvent(context));
export const sendFavouritesAnalyticEvent = (isSignedIn, isSaved, context)=>{
    const signedInUnSavingVehicle = isSaved && isSignedIn;
    const signedInSavingVehicle = !isSaved && isSignedIn;
    const unAuthSavingVehicle = !isSaved && !isSignedIn;
    if (signedInSavingVehicle) sendSaveVehicleEvent(context);
    if (signedInUnSavingVehicle) sendUnSaveVehicleEvent(context);
    if (unAuthSavingVehicle) sendUnAuthSaveVehicleEvent(context);
};
